import React from 'react';
import { useScreenClass } from '@vp/swan';

export default function DesignLines() {
    const screenClass = useScreenClass();

    if (screenClass === 'xs' || screenClass === 'sm') {
        return null;
    }

    return (
        <svg
            width="48"
            height="58"
            viewBox="0 0 48 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                position: 'absolute',
                top: '-36.5',
                right: '-42',
                pointerEvents: 'none',
            }}
        >
            <path
                d="M8.39951 25.4609C7.34727 23.2349 8.71497 18.0942 12.1037 10.8112C12.6743 9.59498 12.828 8.07664 15.4255 7.53817C16.2803 10.1449 14.2655 11.7883 13.7883 13.7923C13.3117 15.8211 12.7606 17.8403 11.9315 19.7653C11.1146 21.6568 11.8671 24.1962 8.39951 25.4609Z"
                fill="#D3D3D3"
            />
            <path
                d="M37.7022 25.6175C30.5886 26.5579 24.0088 29.3267 17.0038 30.6508L16.9639 31.4436C17.5822 31.761 18.3007 32.4643 18.796 32.3512C24.8934 30.9287 30.9622 29.4127 37.0119 27.8344C37.5193 27.7014 37.8261 26.9143 38.226 26.4308C38.0506 26.1571 37.8776 25.8912 37.7022 25.6175Z"
                fill="#D3D3D3"
            />
            <path
                d="M37.3973 48.2047C31.0731 45.077 23.995 43.7127 17.5099 40.9532L16.9649 41.5696C17.2565 42.1626 17.3788 43.1211 17.85 43.3005C23.6696 45.4852 29.5265 47.5789 35.4085 49.6121C35.9023 49.7821 36.6579 49.316 37.292 49.1453C37.3282 48.8292 37.3611 48.5207 37.3973 48.2047Z"
                fill="#D3D3D3"
            />
        </svg>
    );
}
